import MuiIconButton from '@mui/material/IconButton';
import { ThemeProvider, getInvertedTheme } from '../theme';
import type { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';

export interface IconButtonProps extends MuiIconButtonProps {
    inverted?: boolean;
}

export const IconButton = (props: IconButtonProps) => {
    const { inverted, ...restProps } = props;
    const button = <MuiIconButton {...restProps} />;

    if (inverted) {
        const themeInverted = getInvertedTheme();

        return <ThemeProvider theme={themeInverted}>{button}</ThemeProvider>;
    }

    return button;
};
